import { fetchFeatureFlagsApi } from './featureFlagApi';
import {
  FEATURE_FLAGS_FAILURE,
  FEATURE_FLAGS_REQUESTED,
  FEATURE_FLAGS_SUCCESS
} from './featureFlagTypes';

export const fetchFeatureFlags = () => async (dispatch: any) => {
  dispatch({ type: FEATURE_FLAGS_REQUESTED });

  try {
    const flags = await fetchFeatureFlagsApi();
    dispatch({ type: FEATURE_FLAGS_SUCCESS, payload: flags });
  } catch (error) {
    dispatch({
      type: FEATURE_FLAGS_FAILURE,
      payload: { error: error instanceof Error ? error.message : String(error) }
    });
  }
};
